var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSeFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#006aa7",
  d: "M0 0h16v10H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fecc00",
  d: "M5 0h2v10H5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fecc00",
  d: "M0 4h16v2H0z"
})));
export default SvgSeFlag;